/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationPricingsSelfWorkerPricesMutation($input: SaveSimulationPricingsSelfWorkerPrices_M_simulation_pricings_self_workerInput!) {
    saveSimulationPricingsSelfWorkerPrices_M_simulation_pricings_self_worker(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
